/**
 * Busca com cidade fixa ESTRITA (pedido do cs2587, 31/08/2026).
 *
 * O tenant tem "Cidade fixa na busca" (tbl_sites.CidadeBusca → site.cidade_busca)
 * e pediu dois ajustes, gated por site:
 *
 *  1. O select "Condomínios" da busca lista SÓ os empreendimentos da cidade fixa
 *     (no cs2587: 521 de Taubaté, e não os 637 do acervo inteiro).
 *  2. A busca por CÓDIGO vira geral: com a cidade fixa pré-selecionada, o código
 *     ia junto com a cidade na URL e imóvel de outra cidade nunca era achado
 *     (caso real: CA1777 em Tremembé "sumia" com o filtro em Taubaté). Com
 *     código digitado, cidade e bairro saem da busca.
 *
 * Fora do gate, nada muda. A vitrine /condominios NÃO passa por aqui (ela usa
 * o estado allCondominios próprio) — o filtro é só do select de busca.
 */

const SITES_CIDADE_FIXA_ESTRITA = new Set([2587]);

export function buscaCidadeFixaEstrita(siteId: unknown): boolean {
    return SITES_CIDADE_FIXA_ESTRITA.has(Number(siteId));
}

/** Lista crua de empreendimentos → só os da cidade fixa (gate + cidade configurada). */
export function filtrarCondominiosCidadeFixa(
    empreendimentos: Array<any> | undefined | null,
    siteId: unknown,
    cidadeBusca: unknown,
): Array<any> {
    const lista = Array.isArray(empreendimentos) ? empreendimentos : [];
    const cidadeFixa = Number(cidadeBusca || 0);
    if (!buscaCidadeFixaEstrita(siteId) || !cidadeFixa) return lista;
    return lista.filter((e: any) => Number(e?.id_cidade) === cidadeFixa);
}

/**
 * Nome-base do cache de condomínios no localStorage. Sites do gate usam um nome
 * PRÓPRIO: o cache antigo (lista sem filtro) nunca expira sozinho e continuaria
 * aparecendo pra quem já visitou o site. Os demais sites mantêm a chave e o
 * cache que já têm.
 */
export function condominiosStorageName(siteId: unknown): string {
    return buscaCidadeFixaEstrita(siteId) ? 'condominios-cf' : 'condominios';
}
